<div class="c-modal__inner">
  <form class="c-form c-form--d" (ngSubmit)="submit()" [formGroup]="form">
    <div class="c-modal__head">
      <div class="c-modal__close" (click)="close()">
        <p500-ui-icon name="controls-close"></p500-ui-icon>
      </div>
      <div class="c-modal__title">{{ title }}</div>
      <div *ngIf="name" class="c-modal__subtitle"><span i18n="@@settings.preset_name">Preset Name</span>: {{ name }}</div>
    </div>

    <div class="c-modal__body" *ngIf="groups && !isLoading && selectedGroup">
      <div class="row">
        <div class="col-12 col-mx-6 c-form__section">
          <p500-ui-text-field i18n-label="@@common.name" label="Name" [formControl]="presetNameControl"></p500-ui-text-field>
        </div>
        <div class="col-12 col-mx-6 c-form__section">
          <p500-ui-select-field
            bindLabel="name"
            bindValue="model"
            [readonly]="name"
            [data]="groupsData"
            [formControl]="groupsControl"
            i18n-placeholder="@@common.select_data"
            placeholder="Select data..."
            i18n-label="@@common.group"
            label="Group"
          ></p500-ui-select-field>
        </div>

        <div class="col-12 mt-2">
          <div class="c-modal__body-title">
            <div class="title" i18n="@@common.columns">Columns</div>
          </div>
          <!--TODO: Possible errors due to component replacement -->

          <div
            *ngIf="groups[selectedGroup].fieldsGroup | keyvalue: originalOrder as checkboxesGroup"
            [class]="checkboxesGroup.length > 1 ? 'row row-cols-1 row-cols-md-2 row-cols-lg-3' : ''"
          >
            <div *ngFor="let group of checkboxesGroup; count as count" [class]="count > 1 ? 'col mb-16' : ''">
              <div *ngIf="group.key" class="mb-6">{{ group.key }}</div>
              <p500-ui-group-checkbox
                [itemsContainerClass]="count === 1 ? 'c-form c-form--builder' : ''"
                [itemClass]="count === 1 ? 'c-form__section' : 'mb-4'"
                [checkboxes]="group.value"
                [formControl]="columnsControl.get(group.key)"
              ></p500-ui-group-checkbox>
            </div>
          </div>
        </div>

        <div class="col-12 mt-2">
          <div class="c-modal__body-title">
            <div class="title" i18n="@@common.conditions">Conditions</div>
            <div class="actions" (click)="addCondition()">
              <div class="action">
                <div class="c-link c-link--primary -blue"><p500-ui-icon name="plus-circle"></p500-ui-icon></div>
              </div>
            </div>
          </div>
          <div class="c-conditions c-conditions--d">
            <div *ngFor="let condition of conditionsControl.controls; let i = index" class="c-conditions__groups-conditions">
              <p500-ui-preset-condition
                [index]="i"
                [formControl]="condition"
                [conditions]="groups[selectedGroup].conditions"
                [getValueComponentByType]="presetHelpers.getValueComponentByType"
                [getSignsData]="presetHelpers.getSignsData"
                [hiddenOptions$]="hiddenOptions$"
                class="c-conditions__condition c-form__section"
                (remove)="deleteCondition(i)"
              >
              </p500-ui-preset-condition>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="c-modal__body" *ngIf="!groups || isLoading">
      <p500-ui-cube-preloader></p500-ui-cube-preloader>
    </div>
    <div class="c-modal__footer">
      <div class="c-modal__action">
        <button p500-ui-button [stroked]="true" type="button" (click)="close()" i18n="@@common.cancel">Cancel</button>
      </div>
      <div class="c-modal__action">
        <button p500-ui-button classIcon="p500-ui-icon-check" type="submit" [disabled]="form.invalid" i18n="@@common.save">Save</button>
      </div>
    </div>
  </form>
</div>
